'use strict';

module.exports = {
  printThreshold: 7,
  nFloatingValues: 5
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/numjs/src/config.js
// module id = 98
// module chunks = 0